import { createSelector } from '@reduxjs/toolkit';

export const selectFeatureFlagSlice = (state) => state.featureFlag;

export const selectFeatureFlagData = createSelector([selectFeatureFlagSlice], (slice) => slice?.featureFlagData);
